export type ClassName = string | undefined | null | false

export function cx(...classes: ClassName[]): string {
  return classes.filter(Boolean).join(' ')
}
